import React, { Component } from 'react';
import { observer } from 'mobx-react';
import LoadingSpinner from '../../LoadingSpinner';
import DashPanel from '../../DashPanel';
import Header from '../../DashPanel/Header';
import Content from '../../DashPanel/Content';
import Pagination from '../../DashPanel/Pagination';
import Title from '../../DashPanel/Title';
import DropMenu from '../../DashPanel/DropMenu';
import NotFound from './NotFound';
import MsellerListDashboardStore from 'js/stores/pages/AdminDashboardPage/MsellerListDashboardStore';
import ListItem from 'js/components/pages/AdminDashboardPage/List/ListItem';
import MSellerListSummary from 'js/components/pages/AdminDashboardPage/MsellerList/MsellerList/MsellerListSummary';
import Row from 'js/components/pages/AdminDashboardPage/List/Row';
import ListMessage from 'js/components/pages/AdminDashboardPage/List/ListMessage';

@observer
export default class Dashboard extends Component {
  msellerListDashboard = MsellerListDashboardStore.create({ page: parseInt(this.props['*']) || 1 });

  constructor(props) {
    super(props);
    this.msellerListDashboard.load();
  }

  componentDidUpdate() {
    this.msellerListDashboard.setPage(this.props['*']);

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('f') && urlParams.has('q')) {
      this.msellerListDashboard.setQueryParams({
        field: urlParams.get('f'),
        query: urlParams.get('q'),
      });
    }
  }

  render() {
    return (
      <DashPanel>
        <Header>
          <DropMenu />
          <Title>Msellers list</Title>
          <Pagination model={this.msellerListDashboard} />
        </Header>

        <Content>
          {this.msellerListDashboard.isLoading ? (
            <LoadingSpinner />
          ) : this.msellerListDashboard.msellers.length ? (
            <div>
              <Row>
                <div>
                  <ListItem to={null}>
                    <MSellerListSummary mseller={{
                      'login': 'Username',
                      'mseller_url': 'Mseller url',
                      'location': 'Location',
                      'date': 'Date',
                      'activated': 'Activated'
                    }} />
                  </ListItem>
                </div>
              </Row>
              <Row>
                <div>
                  {this.msellerListDashboard.msellers ? (
                    this.msellerListDashboard.msellers.map(mseller => (
                      <ListItem key={mseller.id} to="#">
                        <MSellerListSummary mseller={mseller} />
                      </ListItem>
                    ))
                  ) : (
                    <ListMessage>No msellers found</ListMessage>
                  )}
                </div>
              </Row>
            </div>
          ) : (
            <NotFound>No msellers found</NotFound>
          )}
        </Content>
      </DashPanel>
    );
  }
}
